import { MATERIAL_LIST_COLUNMN_DEFS, MATERIAL_MODEL } from "./Constants";

export const EXCEL_FILE_DOWNLOAD = (blob) => {
  if (navigator.appVersion.toString().indexOf(".NET") > 0) {
    window.navigator.msSaveBlob(blob, MATERIAL_MODEL + ".xlsx");
  } else {
    let url = window.URL.createObjectURL(blob);
    let a = document.createElement("a");
    a.href = url;
    a.download = MATERIAL_MODEL + ".xlsx";
    a.click();
  }
};

export const CREATE_EXCEL_DATA = ( allExport, searchQuery, filterQuery, selectedRow) => {
  let listItems = [];
  let columns = [];
  for (let i = 0; i < MATERIAL_LIST_COLUNMN_DEFS.length; i++) {
    let value = MATERIAL_LIST_COLUNMN_DEFS[i].field;
    if (value.includes(".")) {
      columns.push(value.split(".")[0]);
    } else {
      if (value.toLowerCase() === "files") {
        continue;
      }
      columns.push(value);
    }
  }
  if (allExport) {
    listItems = "all";
  } else {
    for (let i = 0; i < selectedRow.length; i++) {
      listItems.push(selectedRow[i]);
    }
  }

  let data = {
    results: listItems,
    columns: columns,
    search: searchQuery,
    filter: filterQuery ? filterQuery.slice(0, -1) : null,
    primary_key: "package_no",
  };

  return data;
};
